import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type ChipProps = {
	children: ReactNode;
	className?: string;
};

const Chip = ({ children, className }: ChipProps) => {
	return (
		<span
			className={twMerge(
				'rounded-full bg-mantang-gray-200 px-2 py-1 font-medium text-mantang-gray-700 text-xs',
				className,
			)}
		>
			{children}
		</span>
	);
};

export default Chip;
